export function toast(sMessage) {
    // messages might be escapeXML, so allow anchor tags only
    const re = /&lt;\/a&gt;/g;
    const re2 = /&lt;a(.*?)&gt;/g;

    sMessage = sMessage.replace(re, '</a>').replace(re2, '<a$1>');
    sMessage = sMessage.replace(/&#034;/g, '"');

    const container = $(document.createElement('div'));
    container.addClass('toast');
    const message = $(document.createElement('div'));
    message.addClass('message');
    message.html(sMessage);
    message.appendTo(container);
    container.appendTo(document.body);

    container.delay(100).fadeIn('slow', function () {
        $(this).delay(5000).fadeOut('slow', function () {
            $(this).remove();
        });
    });

    message.mouseover(function () {
        container.stop(true, false).fadeIn('fast');
    });

    container.mouseout(function () {
        $(this).stop(true, false).delay(500).fadeOut('slow', function () {
            $(this).remove();
        });
    });
};
